const TOGGLE_VIEW = "TOGGLE_VIEW";
const RESET_VIEW = "RESET_VIEW";

export default {
    TOGGLE_VIEW,
    RESET_VIEW
}